import React from 'react';
import { PixelTracker } from '../components/PixelTracker';
import { PurchasePopup } from '../components/PurchasePopup';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ProductBreakdown } from '../components/ProductBreakdown';
import { BonusesSection } from '../components/BonusesSection';
import { Testimonials } from '../components/Testimonials';
import { PricingSection } from '../components/PricingSection';
export function SalesPage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-247">
      <PixelTracker data-id="element-248" />
      <PurchasePopup data-id="element-249" />

      <main data-id="element-250">
        <HeroSection data-id="element-251" />
        <ProblemSection data-id="element-252" />
        <SolutionSection data-id="element-253" />
        <ProductBreakdown data-id="element-254" />
        <BonusesSection data-id="element-255" />
        <Testimonials data-id="element-256" />
        <PricingSection data-id="element-257" />
      </main>

      <footer className="bg-gray-900 text-gray-400 py-8 text-center text-sm" data-id="element-258">
        <div className="max-w-4xl mx-auto px-4" data-id="element-259">
          <p className="mb-2" data-id="element-260">
            © {new Date().getFullYear()} Megapack Mentalidad Futbol. Todos los
            derechos reservados.
          </p>
          <p data-id="element-261">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera.
          </p>
        </div>
      </footer>
    </div>;
}